<template>
  <v-container class="py-0">
    <v-row justify="center" align="center" style="min-height:100vh">
      <v-col cols="12">
        <v-card
          width="90%"
          max-width="408"
          class="my-4 mx-auto rounded-lg"
          style="box-shadow: 0px 2px 8px -1px rgba(0, 0, 0, 0.2); z-index: 1;"
        >
          <v-sheet color="#393E46" class="py-10">
            <v-img
              class="ma-auto"
              contain
              width="200"
              :src="require('@/assets/logo-white.png')"
            />
          </v-sheet>
          <div class="pa-5">
            <div class="text-center mb-5 grey--text">
              <p class="title mb-1">
                Monitoring System & Analytics
              </p>
              <p class="caption">
                MONSTA
              </p>
            </div>
            <div class="d-flex align-center">
              <v-divider color="white"></v-divider>
              <div class="mx-1 font-weight-bold light-green--text">
                LOGIN
              </div>
              <v-divider color="white"></v-divider>
            </div>
          </div>
          <div class="pa-5">
            <ValidationObserver ref="observer">
              <v-form
                class="text-left mb-6"
                :readonly="loadingAuth"
                @submit.native.prevent="loginHandler"
              >
                <ValidationProvider
                  name="NRP / NIK"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    :error-messages="formErrors.username || errors"
                    v-model="form.username"
                    autofocus
                    filled
                    rounded
                    dense
                    color="grey darken-3"
                    placeholder="NRP / NIK"
                    @keyup.enter="loginHandler"
                  >
                  </v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  name="Password"
                  rules="required|max:20"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="form.password"
                    :error-messages="formErrors.password || errors"
                    class="mt-2 mb-1"
                    filled
                    color="grey darken-3"
                    rounded
                    dense
                    placeholder="Password"
                    :type="show ? 'text' : 'password'"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show = !show"
                    :counter="20"
                    @keyup.enter="loginHandler"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-form>
            </ValidationObserver>
            <div class="text-center mt-4 mb-4">
              <v-alert
                type="error"
                text
                dense
                prominent
                v-show="error.message !== ''"
                v-html="error.message"
              >
              </v-alert>
              <v-btn
                rounded
                block
                color="light-green"
                :disabled="loadingAuth"
                :loading="loadingAuth"
                @click="loginHandler"
                class="white--text text-capitalize"
              >
                Masuk
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import auth from '@/mixins/auth';
export default {
  mixins: [auth],
  data() {
    return {
      show: false,
      form: {
        username: '',
        password: ''
      }
    };
  },
  methods: {
    async loginHandler() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        try {
          const user = await this.login(this.form);
          if (user.accountAccountGroupId !== '3') {
            this.$router.push('/menu');
          } else {
            this.$router.push('/user');
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e.errors.message);
        }
      }
    }
  }
};
</script>
